module.exports = __webpack_public_path__ + "static/img/samajuri (7).7dafa62.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/samajuri/samajuri (7).jpg
// module id = PilR
// module chunks = 0